'use strict';

/**
 * Sets inline labels - moving the labels inside the input as if it were a placeholder.  The surrounding 
 * container is given the inlineInputLabel class when the label is shown this way.
 * 
 * If the input is focused or contains a value, the label will shift out of the way.
 *
 * @param inputWrapSelector A selector for field elements.  These elements must wrap both the Label and the Input.
 */
function init(inputWrapSelector, labelSelector = 'label') {
  // Have fields listen for changes to enable/disable placeholder labels
  const wrapsWithPlaceholderLabels = document.querySelectorAll(inputWrapSelector);

  wrapsWithPlaceholderLabels.forEach(wrap => {
    const input = wrap.querySelector('input,textarea,select');
    const label = wrap.querySelector(labelSelector);

    if (!input) { return; }
    if (!label) { return; }
    
    if (input.tagName === 'SELECT') {
      insertFirstEmptyOption(input);
    }

    input.addEventListener('change', () => handleInputUpdate(wrap, input, label));
    input.addEventListener('focus', () => handleInputUpdate(wrap, input, label));
    input.addEventListener('blur', () => handleInputUpdate(wrap, input, label));
    input.inlineLabel = { conditionallyDisplayed: false }
    
    // Initialize based on the current value
    handleInputUpdate(wrap, input, label);

    // After initializing, enable transitions.  This avoids the labels from
    // transitioning on page load
    wrap.classList.add('inlineInputLabel--labelTransition');
  });

  /* When a <select> is conditionally shown, gforms some actions that override the inline label.
   * so we reconfigure them the first time they're shown.  If they're hidden/shown again, they'll be fine,
   * so only do it the first time
   */
  window.gform && window.gform.addAction('gform_post_conditional_logic_field_action', function(formId, action, targetId, defaultValues, isInit) {
    if (action !== 'show') { return; }

    const field = document.getElementById(targetId.substring(1));
    if (!field) { return; }
    
    const elSelect = field.querySelector('select');
    if (!elSelect) { return; }

    if (!elSelect.inlineLabel) { return; }
    
    if (elSelect.inlineLabel.conditionallyDisplayed) { return; }

    elSelect.selectedIndex = 0;
    elSelect.inlineLabel.conditionallyDisplayed = true;
  });
}

function insertFirstEmptyOption(elSelect) {
  const emptyOption = document.createElement('option');
  emptyOption.value = '';
  emptyOption.disabled = true;
  emptyOption.classList.add('inlineInputLabel__emptyOption');
  
  elSelect.add(emptyOption, 0);
  elSelect.selectedIndex = 0;
}

function handleInputUpdate(wrap, input, label) {
  const hasValue = !!input.value;
  const hasFocus = (document.activeElement === input);
  const isInline = (!hasValue && !hasFocus);

  wrap.classList.toggle('inlineInputLabel--inline', isInline);
}

// Convenience function for Gravity Forms.  Adds inline labels to all of the texty fields
function initGforms() {
  init(gfieldSelector);
}

const gfieldSelector = '.gfield--type-text'
    + ',.gfield--type-email'
    + ',.gfield--type-phone'
    + ',.gfield--type-textarea'
    + ',.gfield--type-select'
    + ',.ginput_container_address .gform-grid-col';
    
export default { init, initGforms };

/**
 * Copyright 2024 Plaintext Inc.
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
